import { ASSET_PREFIX } from 'utils/constants';

import PopupWithDimmedBackground from './PopupWithDimmedBackground';

export const OutsideUKPopup = ({ onClose }: { onClose: () => void }) => {
  return (
    <PopupWithDimmedBackground
      whiteCloseButton={undefined}
      icon={undefined}
      bannerImage={undefined}
      onClose={onClose}
    >
      <div className="outside-uk-content">
        <img
          className="uk-only-image"
          src={`${ASSET_PREFIX}/images/uk-only.png`}
          width="100px"
        />
        <h3
          style={{
            fontWeight: 800,
            letterSpacing: 'normal',
            textShadow: '2px 2px white',
          }}
        >
          It looks like you are visiting us from outside the United Kingdom
        </h3>
        <p>
          Please note that DAYMADE operates exclusively in the UK and is
          available to UK residents only. We hope to bring the DAYMADE
          experience to your country one day!
        </p>
      </div>

      <style jsx>
        {`
          .outside-uk-content {
            display: flex;
            height: 100%;
            width: 100%;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          .uk-only-image {
            width: 100px;
          }

          @media (max-width: 450px) {
            .uk-only-image {
              width: 70px;
            }
          }
        `}
      </style>
    </PopupWithDimmedBackground>
  );
};
